const baseStyle = {
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full",
    shadow: "md",
    bg: "#fff",
    rounded: "md",
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "start",
  },
  td: {
    textAlign: "start",
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium",
  },
};

const numericStyles = {
  "&[data-is-numeric=true]": {
    textAlign: "end",
  },
};

const variantSimple = (props) => {
  const { colorMode, colorScheme: c } = props;

  return {
    th: {
      color: colorMode === "light" ? "gray.600" : "gray.400",
      borderBottom: "1px",
      ...numericStyles,
    },
    td: {
      borderBottom: "1px",
      borderColor: colorMode === "light" ? `${c}.200` : `${c}.700`,
      ...numericStyles,
      background: "#fff !important",
    },
    caption: {
      color: colorMode === "light" ? "gray.600" : "gray.100",
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 },
        },
      },
    },
  };
};

const variantStripeThemed = (props) => {
  const { colorMode, colorScheme: c } = props;

  return {
    th: {
      color: colorMode === "light" ? "gray.600" : "gray.400",
      borderBottom: "1px",
      borderColor: colorMode === "light" ? `${c}.200` : `${c}.700`,
      ...numericStyles,
    },
    td: {
      ...numericStyles,
    },
    caption: {
      color: colorMode === "light" ? "gray.600" : "gray.200",
    },
    tbody: {
      tr: ({ index }) => ({
        content: index,
        _hover: {
          cursor: "pointer",
          bg: "brand.primary.100",
        },
        _odd: {
          bg: "gray.100",
          _hover: {
            cursor: "pointer",
            bg: "brand.primary.100",
          },
        },
      }),
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 },
        },
      },
    },
  };
};

const variants = {
  simple: variantSimple,
  variantStripeThemed: variantStripeThemed,
  unstyled: {},
};

const sizes = {
  sm: {
    th: {
      px: "4",
      py: "3",
      lineHeight: "4",
      fontSize: "sm",
    },
    td: {
      px: "4",
      py: "2",
      lineHeight: "4",
      fontSize: "sm",
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs",
    },
  },
  md: {
    th: {
      px: "6",
      py: "4",
      lineHeight: "4",
      fontSize: "xs",
    },
    td: {
      px: "6",
      lineHeight: "4",
      py: "4",
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm",
    },
  },
  lg: {
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm",
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6",
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md",
    },
  },
};

const defaultProps = {
  variant: "simple",
  size: "md",
  colorScheme: "gray",
};

export default {
  components: {
    Table: {
      baseStyle,
      variants,
      sizes,
      defaultProps,
    },
  },
};
